import * as React from 'react';

function FinancialAnalystUsage({profile} :any) {
  let bonus_questions     = profile.financial_analyst_usage_meter?.bonus_questions
  let premium_questions   = profile.financial_analyst_usage_meter?.premium_questions
  let executive_questions = profile.financial_analyst_usage_meter?.executive_questions

  let user_plan = profile.financial_analyst_usage_meter?.user_plan

  function bonus_questions_percentage() {
    return Math.round((bonus_questions.used / bonus_questions.max) * 100);
  }

  function premium_questions_percentage() {
    return Math.round((premium_questions.used / premium_questions.max) * 100);
  }

  function executive_questions_percentage() {
    return Math.round((executive_questions.used / executive_questions.max) * 100);
  }

  return (
    <div className="template-demo">
      <div className="d-flex justify-content-between">
        <small>Bonus Financial Analyst questions</small>
        <small>{bonus_questions.used + '/' + bonus_questions.max}</small>
      </div>
      <div className="progress progress-lg mt-2">
        <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': bonus_questions_percentage() + '%'}}>{bonus_questions_percentage() + '%'}</div>
      </div>
      { user_plan == 'premium' ? (
        <span>
          <div className="d-flex justify-content-between mt-2">
            <small>Premium Financial Analyst questions (This month)</small>
            <small>{premium_questions.used + '/' + premium_questions.max}</small>
          </div>
          <div className="progress progress-lg mt-2">
            <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': premium_questions_percentage() + '%'}}>{premium_questions_percentage() + '%'}</div>
          </div>
        </span>
      ) : null}
      { user_plan == 'executive' ? (
        <span>
          <div className="d-flex justify-content-between mt-2">
            <small>Executive Financial Analyst questions (This Month)</small>
            <small>{executive_questions.used + '/' + executive_questions.max}</small>
          </div>
          <div className="progress progress-lg mt-2">
            <div className="progress-bar bg-danger" role="progressbar" style={{ 'width': executive_questions_percentage() + '%'}}>{executive_questions_percentage() + '%'}</div>
          </div>
        </span>
      ) : null}
    </div>
  );
}

export default FinancialAnalystUsage;
